const SYMBOL_REGEX = /(?![-_A-Za-z0-9-_])[!-~]/;

export const getPrefixFromNamespace = (namespace: string) => {
  if (!namespace) {
    return '';
  }
  const stringArr = namespace.split(SYMBOL_REGEX);
  stringArr.reverse();

  // make sure that the new prefix will not start with a - or _ since we dont filter those out with the regex
  let lastNonEmptyEntry = '';
  stringArr.some((strValue) => {
    if (!strValue.length) {
      return false;
    }

    let trimmedValue = strValue;
    while (trimmedValue.startsWith('-') || trimmedValue.startsWith('_')) {
      trimmedValue = trimmedValue.substring(1);
    }
    lastNonEmptyEntry = trimmedValue;
    return Boolean(trimmedValue.length);
  });

  return lastNonEmptyEntry;
};
